import { render, staticRenderFns } from "./ImportPaxItemsPopup.vue?vue&type=template&id=58f51ddd&scoped=true&"
import script from "./ImportPaxItemsPopup.vue?vue&type=script&lang=js&"
export * from "./ImportPaxItemsPopup.vue?vue&type=script&lang=js&"
import style0 from "./ImportPaxItemsPopup.vue?vue&type=style&index=0&id=58f51ddd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f51ddd",
  null
  
)

export default component.exports